<form [formGroup]="formGroup">
  <div class="d-flex flex-column filter-background">
    <div class="field-container">
      <h3> {{'createUser.privacyPolicy.title'|translate}}</h3>
    </div>
    <mat-checkbox formControlName="accepted">
      {{'createUser.privacyPolicy.checkbox'|translate}} (<a [href]="Route.DATAPROTECTION">{{location}}</a>)
    </mat-checkbox>

  </div>
</form>
